import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Alert,
  Typography
} from '@mui/material';

const MIN_JUSTIFICATION_LENGTH = 20;

const WorkOrderAmOverrideDialog = ({ open, onClose, onConfirm, actionLabel = 'edit this work order' }) => {
  const [justification, setJustification] = useState('');
  const [error, setError] = useState('');

  const handleClose = () => {
    setJustification('');
    setError('');
    onClose();
  };

  const handleConfirm = () => {
    const cleaned = justification.trim();
    if (cleaned.length < MIN_JUSTIFICATION_LENGTH) {
      setError(`Override justification must be at least ${MIN_JUSTIFICATION_LENGTH} characters.`);
      return;
    }
    onConfirm(cleaned);
    setJustification('');
    setError('');
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Accountable Manager Override Required</DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          <Typography variant="body2">
            As Accountable Manager, you must provide a written justification to {actionLabel}.
            This action will be recorded in the audit trail.
          </Typography>
        </Alert>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <TextField
          fullWidth
          multiline
          rows={4}
          required
          label="Override Justification"
          value={justification}
          onChange={(e) => {
            setJustification(e.target.value);
            if (error) setError('');
          }}
          placeholder="Explain why this override is necessary..."
          helperText={`${justification.trim().length}/${MIN_JUSTIFICATION_LENGTH} characters minimum`}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="warning"
          disabled={justification.trim().length < MIN_JUSTIFICATION_LENGTH}
        >
          Proceed with Override
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WorkOrderAmOverrideDialog;
